import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { Helmet } from "react-helmet";

const ContactPage = () => {
  // State for form fields
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  // Handle input changes
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // Handle form submit with EmailJS
  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    emailjs.send(
      'service_z8xysya', // TODO: Replace with your EmailJS service ID
      'template_h8pvv3h', // TODO: Replace with your EmailJS template ID
      {
        from_name: formData.name,
        from_email: formData.email,
        phone: formData.phone,
        message: formData.message
      },
      'Z2vqBzsSRrqsdXWAz' // TODO: Replace with your EmailJS public key
    )
    .then((result) => {
      setSuccess(true);
      setFormData({ name: '', email: '', phone: '', message: '' });
    }, (error) => {
      setError('Failed to send message. Please try again.');
    });
  };

  return (
    <>
      <Helmet>
        <title>Contact | Milstone Associates</title>
        <meta name="description" content="Contact Milstone Associates for MEP design, engineering, and supervision services. Get in touch with our expert team today!" />
        <meta property="og:title" content="Contact | Milstone Associates" />
        <meta property="og:description" content="Contact Milstone Associates for MEP design, engineering, and supervision services. Get in touch with our expert team today!" />
        <meta property="og:image" content="/images/logo.png" />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="min-h-screen flex items-center justify-center bg-white py-12 mt-12 md:mt-20">
        <div className="w-full max-w-6xl bg-white rounded-xl shadow p-8 md:p-12 flex flex-col md:flex-row gap-12">
          {/* Left: Form */}
          <form className="flex-1 bg-gray-50 rounded-lg p-8" onSubmit={handleSubmit}>
            <h2 className="text-3xl font-bold mb-8">Send A Message</h2>
            {success && <div className="mb-4 text-green-600 font-semibold">Thank you! Your message has been sent.</div>}
            {error && <div className="mb-4 text-red-600 font-semibold">{error}</div>}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label className="block font-semibold mb-2">Name/Company Name*</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Your Name"
                  className="w-full border border-gray-400 rounded p-3 bg-white"
                />
              </div>
              <div>
                <label className="block font-semibold mb-2">Email*</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="Email Address"
                  className="w-full border border-gray-400 rounded p-3 bg-white"
                />
              </div>
            </div>
            <div className="mb-6">
              <label className="block font-semibold mb-2">Phone*</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                placeholder="Phone"
                className="w-full border border-gray-400 rounded p-3 bg-white"
              />
            </div>
            <div className="mb-6">
              <label className="block font-semibold mb-2">Project Details*</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                placeholder="Project Detail"
                className="w-full border border-gray-400 rounded p-3 bg-white min-h-[120px]"
              />
            </div>
            <button type="submit" className="bg-[#232323] text-white px-8 py-3 rounded font-semibold text-lg mt-2">
              Submit
            </button>
          </form>
          {/* Right: Contact Info */}
          <div className="flex-1 flex flex-col justify-start items-start pl-0 md:pl-8">
            <h2 className="text-3xl font-bold mb-8">Contact Us</h2>
            <div className="text-lg mb-4">Address: Off#817, 8th Floor, Al-Hafeez Shopping Mall, Main Boulevard Gulberg, Lahore.</div>
            
            <div className="text-lg mb-2">+92 345 7481530</div>
            <div className="text-lg mb-2">mailto:milestoneassociatesconsultants@gmail.com</div>
            
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactPage; 